/* lua.js generated code 0.3.0 */

var UserProductTypeBase = xClass("UserProductTypeBase")
UserProductTypeBase.prototype.ctor = function () {
    var self = this
    self.getProductInfoScheduler = null
    self.productInfo = table()
    self.finishLoadOnline = false
}
UserProductTypeBase.prototype.getProductInfo = function (successCallback, failCallback, timeoutCallback, cancelCallback) {
    var self = this
    if (type(successCallback) === "function") {
        successCallback(table())
    }
}
UserProductTypeBase.prototype.canBuyProduct = function (id) {
    var self = this
    // FIXME: multi result
    return [false, ZooErrorCode.BUY_PRODUCTID_INVALID]
}
UserProductTypeBase.prototype.deal = function (id, successCallback, failCallback, cancelCallback, source = ModuleName.SHOP, dcCashData = null) {
    var self = this
    // body
    if (type(failCallback) === "function") {
        failCallback(table([1, "data", ZooErrorCode.BUY_PRODUCTID_INVALID]))
    }
}
UserProductTypeBase.prototype.buyProduct = function (id, successCallback, failCallback, cancelCallback, source = ModuleName.SHOP, dcCashData = null) {
    var self = this
    source = source || ModuleName.SHOP

    if (!dcCashData || !dcCashData.scence || !dcCashData.session) {
        console.error("[UserProduct.buyProduct] dcCashData is not vaild." + JSON.stringify(dcCashData));
        window.logCenter && logCenter.error(new Error("[UserProduct.buyProduct] dcCashData is not vaild." + JSON.stringify(dcCashData)), "DCCashError");
        dcCashData = null;
    } else if (dcCashData.goodsId){
        DCAssist.dc4BuyCashGoods(dcCashData.session, dcCashData.scence, dcCashData.goodsId, dcCashData.entry, dcCashData);
    } else {
        let productMeta = MetaManager.getProductMetaByID(id)
        if (productMeta)
            DCAssist.dc4BuyCashGoods(dcCashData.session, dcCashData.scence, productMeta.goodsId, dcCashData.entry, dcCashData);
    }

    function success() {
        var __VA_ARG = $slice(arguments, 0)
        // body
        if (PayManager.getInstance().isGuideCustomer()){
            let temp = {
                session: dcCashData.session,
                entry: "force"
            };
            if(dcCashData.entryPanel) {
                temp.entryPanel = dcCashData.entryPanel
            };

            PayManager.getInstance().showGuidePanel(()=>{
                self.deal(id, successCallback, failCallback, cancelCallback, source, dcCashData)
            },temp)
        }else{
            self.deal(id, successCallback, failCallback, cancelCallback, source, dcCashData)
        }
    }
    function fail(evt) {
        // body
        if (failCallback) {
            failCallback(evt)
        }
    }
    VerifiedManager.getInstance().check(success, fail, source)
}
module.exports = UserProductTypeBase
